// Disable all toast notifications by replacing with no-op functions
const toast = {
  success: () => {},
  error: () => {},
  loading: () => {},
  promise: () => {},
  dismiss: () => {},
  remove: () => {}
};

// Mock the socket.io-client import to prevent actual WebSocket connections
const io = () => {
  return {
    on: () => {},
    off: () => {},
    emit: () => {},
    disconnect: () => {},
    removeAllListeners: () => {},
    connect: () => {},
  };
};

// Import the PushNotificationService class
import PushNotificationService from "./pushNotificationService";

class SocketService {
  constructor() {
    this.socket = null;
    this.isConnected = false;
    this.reconnectAttempts = 0;
    this.maxReconnectAttempts = 5;
    this.reconnectDelay = 1000;

    // Initialize push notification service as a disabled instance
    this.pushNotificationService = new PushNotificationService();
  }

  // Completely disable WebSocket connection
  connect(token, userId, userRole) {
    // Do nothing - WebSocket connections are disabled
    console.log("🔌 WebSocket connections are disabled");
    return Promise.resolve(); // Return a resolved promise to match expected interface
  }

  // Completely disable WebSocket disconnection
  disconnect() {
    // Do nothing - WebSocket connections are disabled
    return Promise.resolve(); // Return a resolved promise to match expected interface
  }

  // Completely disable event handlers
  setupEventHandlers() {
    // Do nothing - all event handlers are disabled
    return;
  }

  // Override all emit methods to do nothing
  emitExamAttemptStarted(data) {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  emitExamAttemptCompleted(data) {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  emitBookingCreated(data) {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  emitPaymentProcessed(data) {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  emitUserLogin(data) {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  emitUserLogout(data) {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  sendNotification(userId, message, type = "info") {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  // --- Monitoring events ---
  emitStartExamMonitoring(data) {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  emitWebcamStream(data) {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  emitScreenStream(data) {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  emitMonitoringError(data) {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  // Override all listener methods to do nothing
  onExamAttemptStarted(callback) {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  onExamAttemptCompleted(callback) {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  onBookingCreated(callback) {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  onPaymentProcessed(callback) {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  onUserLogin(callback) {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  onUserLogout(callback) {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  onNotificationReceived(callback) {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  onNewExamAvailable(callback) {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  // Override all remove listener methods to do nothing
  offExamAttemptStarted(callback) {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  offExamAttemptCompleted(callback) {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  offBookingCreated(callback) {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  offPaymentProcessed(callback) {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  offUserLogin(callback) {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  offUserLogout(callback) {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  offNotificationReceived(callback) {
    // Do nothing - WebSocket communications are disabled
    return this;
  }

  // Clean up all event listeners
  cleanup() {
    // Do nothing - WebSocket connections are disabled
    return this;
  }
}

// Export an instance of the SocketService class
const socketService = new SocketService();

export default socketService;